import { Component, EventEmitter, HostListener, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { UiPanelAction } from '../../models/ui-document-panel.model';

@Component({
  selector: 'app-ui-document-panel-footer',
  templateUrl: './ui-document-panel-footer.component.html',
  styleUrls: ['./ui-document-panel-footer.component.scss']
})
export class UiDocumentPanelFooterComponent implements OnChanges {
  @Input() primaryActions: UiPanelAction[] = [];
  @Input() secondaryActions: UiPanelAction[] = [];
  @Input() destructiveAction: UiPanelAction | null = null;
  @Input() overflowActions: UiPanelAction[] = [];
  @Output() actionClick = new EventEmitter<string>();

  overflowMenuOpen = false;
  visiblePrimaryActions: UiPanelAction[] = [];
  visibleSecondaryActions: UiPanelAction[] = [];
  visibleOverflowActions: UiPanelAction[] = [];

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['primaryActions']) {
      const next = this.filterVisible(this.primaryActions);
      if (!this.sameActions(this.visiblePrimaryActions, next)) {
        this.visiblePrimaryActions = next;
      }
    }
    if (changes['secondaryActions']) {
      const next = this.filterVisible(this.secondaryActions);
      if (!this.sameActions(this.visibleSecondaryActions, next)) {
        this.visibleSecondaryActions = next;
      }
    }
    if (changes['overflowActions']) {
      const next = this.filterVisible(this.overflowActions);
      if (!this.sameActions(this.visibleOverflowActions, next)) {
        this.visibleOverflowActions = next;
      }
    }
  }

  trackByActionId(_index: number, action: UiPanelAction): string {
    return action?.id || String(_index);
  }

  private filterVisible(actions: UiPanelAction[] | null | undefined): UiPanelAction[] {
    return (actions || []).filter(a => a && a.visible !== false);
  }

  private sameActions(a: UiPanelAction[], b: UiPanelAction[]): boolean {
    if (a.length !== b.length) return false;
    return a.every((action, i) => {
      const other = b[i];
      return action.id === other.id
        && action.label === other.label
        && action.icon === other.icon
        && action.variant === other.variant
        && !!action.disabled === !!other.disabled;
    });
  }

  toggleOverflowMenu(event: Event): void {
    event.stopPropagation();
    this.overflowMenuOpen = !this.overflowMenuOpen;
  }

  onOverflowAction(id: string, event: Event): void {
    event.stopPropagation();
    this.overflowMenuOpen = false;
    this.actionClick.emit(id);
  }

  onAction(id: string): void {
    this.overflowMenuOpen = false;
    this.actionClick.emit(id);
  }

  @HostListener('document:click', ['$event'])
  closeOverflowMenu(event: MouseEvent): void {
    if (!this.overflowMenuOpen) {
      return;
    }
    const target = event.target as HTMLElement | null;
    if (target?.closest?.('.ui-doc-footer__overflow')) {
      return;
    }
    this.overflowMenuOpen = false;
  }
}
